import { useEffect } from 'react';
import { $getRoot } from 'lexical';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $transformTextToMentionNodes } from 'lexical-beautiful-mentions';
// eslint-disable-next-line import/no-extraneous-dependencies
import { $convertFromMarkdownString, TRANSFORMERS } from '@lexical/markdown';
import PropTypes from 'prop-types';

// Automatically updates Lexical editor when text prop changes,
// now parsing Markdown as well as mentions.
const LexicalContentUpdaterPlugin = ({ text, PUNCTUATION }) => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    let modifiedText = text;

    // If there is only one mention, append a space to trigger recognition
    if (modifiedText?.trim().split(/\s+/).length === 1) {
      modifiedText = `${modifiedText} `;
    }

    editor.update(() => {
      const root = $getRoot();
      root.clear();

      // Convert the Markdown string into Lexical nodes
      $convertFromMarkdownString(modifiedText, TRANSFORMERS);

      // Then transform any @/# mentions
      $transformTextToMentionNodes(['@', '#'], PUNCTUATION);
    });
  }, [editor, text]);

  return null;
};

LexicalContentUpdaterPlugin.propTypes = {
  text: PropTypes.string.isRequired,
  PUNCTUATION: PropTypes.string.isRequired
};

export { LexicalContentUpdaterPlugin };
